import KeenSlider from 'keen-slider';
import { BlockCustomHtml } from '@/javascripts/components/BlockCustomHtml';
import Like from '@/javascripts/components/Like';
import Mute from '@/javascripts/components/Mute';
import { initViewMode } from '@/javascripts/editor/init_view_mode';
import { bindCustomLinkPostEvent } from '@/javascripts/custom_link_menu';
import { mountReactComponents } from '@/utils/react_mount';
import { communityComponents } from '@/components/mountable/registry';

const PageLayoutTop = {
  requestInitPosts: function (initPostUrl: string) {
    $.ajax({
      type: 'GET',
      url: initPostUrl,
      dataType: 'script',
    }).done(() => { });
  },
  initPostsByCallbackAndPostTagId: function (initPostUrl: string, postTagId: string) {
    if (window.IntersectionObserver) {
      const options = {
        root: null,
        rootMargin: '100px',
        threshold: 0,
      };

      const handleIntersect = (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.requestInitPosts(initPostUrl);
            observer.unobserve(entry.target);
          }
        });
      };

      const observer = new IntersectionObserver(handleIntersect, options);
      const target = document.querySelector(postTagId);
      if (target) {
        observer.observe(target);
      }
    } else {
      this.requestInitPosts(initPostUrl);
    }
  },
  bindCustomLinkPostEvent: function (doc: Document) {
    bindCustomLinkPostEvent(doc);
  },
};

if (!customElements.get('block-custom-html')) {
  customElements.define('block-custom-html', BlockCustomHtml);
}

if (!window.Coorum) {
  window.Coorum = {};
}
window.Coorum.PageLayoutTop = PageLayoutTop;
window.Coorum.KeenSlider = KeenSlider;
window.Coorum.Like = Like;
window.Coorum.Mute = Mute;
// AJAX で遅延ロードされたブロック内の React 島（SNS いいね等）をマウントするため公開。
// 基盤は load 時 1 回しか走査しないので、.js.erb から挿入後に呼ぶ。
window.Coorum.mountReactComponents = (root: HTMLElement) =>
  mountReactComponents(communityComponents, root);

$(() => {
  initViewMode();
});
